<template>
<div>
  <!-- class="display-1" -->
  <h1 style="
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: #cccccc;
      ">
    Luna Observatory Internet Telescope
  </h1>
  <p>南阿蘇ルナ天文台の望遠鏡をインターネット上で予約／使用できる、オンライン天文台・利用システムです。</p>
  <p>ご利用にはログインが必要です。</p>
  <div id="firebase-auth-container"></div>
  <div id="firebase-auth-loader">Loading...</div>
</div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import store from '../store'

export default {
  name: 'index',
  data() {
    return {
      firebase: {
        ui: firebaseui.auth.AuthUI.getInstance()
      }
    };
  },
  created() {
    let user = firebase.auth().currentUser
    if ( user ) {
      if ( user.emailVerified ) {
        this.$router.push({
          name: "home"
        })
      } else{
        this.$router.push({
          name: "emailverification"
        })
      }
    }
},
  mounted() {
    this.firebase.ui.start("#firebase-auth-container", {
      callbacks: {
        signInSuccess: (currentUser, credential, redirectUrl) => {
          store.loginUser.session.user = currentUser;
          return true;
        },
        uiShown: () => {
          document.getElementById("firebase-auth-loader").style.display = "none";
        }
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      signInSuccessUrl: "/"+this.$router.resolve("home").href
    })
  },
  methods: {
    openLogin() {
      if (this.$parent.$refs.modal) {
        this.$parent.$refs.modal.show();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Index.vue